import { motion } from 'framer-motion'
import { useInView } from 'framer-motion'
import { useRef } from 'react'

interface CharacterRevealProps {
  text: string
  className?: string
  delay?: number
  duration?: number
}

export default function CharacterReveal({
  text,
  className = '',
  delay = 0,
  duration = 0.05,
}: CharacterRevealProps) {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, margin: '-100px' })

  return (
    <span ref={ref} className={className}>
      {text.split('').map((char, index) => (
        <motion.span
          key={index}
          initial={{ opacity: 0, y: 20 }}
          animate={
            isInView
              ? {
                  opacity: 1,
                  y: 0,
                }
              : { opacity: 0, y: 20 }
          }
          transition={{
            delay: delay + index * duration,
            duration: 0.3,
            ease: [0.25, 1, 0.5, 1],
          }}
          style={{ display: 'inline-block' }}
        >
          {char === ' ' ? '\u00A0' : char}
        </motion.span>
      ))}
    </span>
  )
}


